import { z } from 'zod';
import { PROXY_CONTEXT_TTL_SECONDS } from './proxy-context.dto';

export const SECRET_CREDENTIAL_MAP_KEY_PREFIX = 'terra:secret-credential-map';
export const SECRET_CREDENTIAL_MAP_TTL_SECONDS = PROXY_CONTEXT_TTL_SECONDS;
export const SECRET_CREDENTIAL_AMBIGUOUS_VALUE = '__ambiguous__';

export const SecretCredentialMapSchema = z.record(z.string(), z.string());

export type SecretCredentialMapDto = z.infer<typeof SecretCredentialMapSchema>;

export function getSecretCredentialMapCacheKey({
  tenantId,
  threadId,
}: {
  tenantId: string;
  threadId: string;
}): string {
  return `${SECRET_CREDENTIAL_MAP_KEY_PREFIX}:${tenantId}:${threadId}`;
}
